import { flatModuleObject } from "@/utils/module";

const ms = (require as IMRequire).context("./th-TH", true, /\.(ts|js)$/);

const langs = flatModuleObject(ms, false);

export default langs;
